import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    current: {},
    currentList: [],
    deletedImages: []
  },
  getters: {},
  mutations: {
    setCurrentList (state, errorRecordList) {
      state.currentList = errorRecordList
    },
    setCurrent (state, errorRecord) {
      state.deletedImages = []
      state.current = errorRecord
    },
    addDeletedImage (state, deletedImage) {
      state.deletedImages.every(image => image._id !== deletedImage._id) && state.deletedImages.push(deletedImage)
    },
    clearDeletedImages (state) {
      state.deletedImages = []
    }
  },
  actions: {
    setNewErrorRecord ({rootState, commit}) {
      commit('setCurrent', {
        type: rootState.enumData.errorRecordType.construction.value,
        description: null,
        notifiedAt: null,
        deadLine: null,
        images: []
      })
    },
    async storeErrorRecord ({commit, rootState}, _id) {
      const errorRecord = await api.getErrorRecord(_id)
      errorRecord.images = Object.values(rootState.enumData.errorRecordTiming).map(timing => {
        const image = errorRecord.images.find(image => timing.value === image.timing)
        return (
          image || {
            _id: Math.random().toString(),
            timing: timing.value
          }
        )
      })
      commit('setCurrent', errorRecord)
    },
    async add ({rootState, state, dispatch, commit}, unitType) {
      const newErrorRecord = {...state.current}
      delete newErrorRecord.images

      const _id = await api.addErrorRecord({
        ...newErrorRecord,
        project: rootState.project.current._id,
        unitType: unitType
      })

      for (const image of state.current.images) {
        await dispatch('addImage', {_id, imageData: image.file, meta: {extension: image.file.name.split('.').pop()}})
      }

      await dispatch('storeErrorRecordList')
    },
    async patch ({ state, dispatch, commit }) {
      const newErrorRecord = {...state.current}
      const originImages = state.current.images.filter(image => !image.file && image.src)
      newErrorRecord.images = originImages
      await api.updateErrorRecord(newErrorRecord)
      // 新增新圖片
      for (const image of state.current.images.filter(image => image.file)) {
        await dispatch('addImage',
          {_id: state.current._id,
            imageData: image.file,
            meta: {extension: image.file.name.split('.').pop(), timing: image.timing, description: image.description, date: image.date}
          })
      }

      // // 刪除舊圖片
      for (const image of state.deletedImages) {
        await api.deleteErrorRecordImage(state.current._id, image._id)
      }
      commit('clearDeletedImages')

      await dispatch('storeErrorRecordList')
    },
    async storeErrorRecordList ({rootState, commit}, filterOptions) {
      commit('setCurrentList', await api.getErrorRecords(rootState.project.current._id, filterOptions))
    },
    async addImage ({state}, {_id, imageData, meta}) {
      const { location } = await api.addErrorRecordImageMeta(_id, meta)

      await api.addErrorRecordImageContent(location, imageData)
    },
    async batchDownload ({state}, {ids, unitType}) {
      const result = await api.downloadErrorRecord(ids, unitType)
      require('downloadjs')(result, `矯正與預防處理紀錄.docx`)
    },
    async downloadList ({rootState}, unitType) {
      const result = await api.downloadErrorRecordList(rootState.project.current._id, unitType)
      require('downloadjs')(result, `矯正與預防處理紀錄.zip`)
    },
    async delete ({state, dispatch}, id) {
      await api.deleteErrorRecord(id)
      await dispatch('storeErrorRecordList')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/errorRecord.js